import React, { Component } from 'react';

//components
import CariAppFormStepper from "../../../../components/cari_app_form_components/CariAppFormStepper";
import CariAppFormNavBtnBar from "../../../../components/cari_app_form_components/CariAppFormNavBtnBar";

//views
import CariAppFormContainerPg1 from "../../../cari_app_form_view/container/CariAppFormContainerPg1";
import CariAppFormContainerPg2 from "../../../cari_app_form_view/container/CariAppFormContainerPg2";
import CariAppFormContainerPg3 from "../../../cari_app_form_view/container/CariAppFormContainerPg3";
import CariAppFormContainerPg4 from "../../../cari_app_form_view/container/CariAppFormContainerPg4";

//generic function
import {
    isEmpty
} from "../../../../../../functions/generic_functions";

//router
import { 
    Route, 
    Switch,
    Redirect
} from 'react-router-dom';

//import static routes
import { 
    cari_app_form_pg_1_url, 
    cari_app_form_pg_2_url, 
    cari_app_form_pg_3_url, 
    cari_app_form_pg_4_url 
} from "../../../../../../router/static_routes";

/*
    props 
        match => from history of routing
*/
class CariAppFormPgLayoutRouting extends Component {

    state = {

    }

    constructor(Props) {
        super(Props);
        //helper functions
        this.getCariFormPgNum = this.getCariFormPageNum.bind(this);
    }

    getCariFormPageNum() {
        var currentUrl = window.location.pathname;
        var current_cari_pg = null;
        //check which url it corresponds to
        if (currentUrl === cari_app_form_pg_1_url) {
            current_cari_pg = 1;
        }
        else if (currentUrl === cari_app_form_pg_2_url) {
            current_cari_pg = 2;
        }
        else if (currentUrl === cari_app_form_pg_3_url) {
            current_cari_pg = 3;
        }
        else if (currentUrl === cari_app_form_pg_4_url) {
            current_cari_pg = 4;
        }
        else {
            return undefined;
        }
        return current_cari_pg;
    }

    render() {
        return (
            <div>
                <br />
                <div className="p-grid">
                    <div className="p-col-12" >
                        <CariAppFormStepper 
                            page_num={this.getCariFormPageNum()}
                            match={this.props.match}
                        />
                    </div>
                </div>

                <div className="p-grid">
                    <div className="p-col-12" >
                        
                        <Switch>
                            <Route 
                                exact 
                                path={cari_app_form_pg_1_url} 
                                component={CariAppFormContainerPg1}
                            />
                            <Route 
                                exact
                                path={cari_app_form_pg_2_url} 
                                component={CariAppFormContainerPg2}
                            />
                            <Route 
                                exact
                                path={cari_app_form_pg_3_url} 
                                component={CariAppFormContainerPg3}
                            />
                            <Route 
                                exact
                                path={cari_app_form_pg_4_url} 
                                component={CariAppFormContainerPg4}
                            />
                            <Redirect
                                from='*'
                                to={cari_app_form_pg_1_url}
                            />
                        </Switch>

                    </div>
                </div>
            </div>
        );
    }
}
export default CariAppFormPgLayoutRouting;